import React from 'react';
import { Paper, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useQrCode } from '../../hooks/useQrCode';
import { QrCodeGenerator } from './QrCodeGenerator';
import { QrCodeControls } from './QrCodeControls';
import ListTitleBox from '../../../../../app/components/list/ListTitleBox';

export const QrCode: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const [searchParams] = useSearchParams();
  const tableNumber = searchParams.get('tableNumber');

  const {
    customText,
    selectedSize,
    qrRef,
    isDownloading,
    handleCustomTextChange,
    handleSizeChange,
    handleDownload,
    handlePrint,
  } = useQrCode(tableNumber!);

  const handleBack = React.useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!tableNumber) {
    return null;
  }

  return (
    <>
      <ListTitleBox
        title={t('qr-code.title')}
        onBackClick={handleBack}
        paddingBottom={2}
      />
      <Paper sx={{ p: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <QrCodeGenerator
              ref={qrRef}
              restaurantId={restaurantId!}
              tableNumber={tableNumber}
              customText={customText}
              size={selectedSize}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <QrCodeControls
              customText={customText}
              selectedSize={selectedSize}
              isDownloading={isDownloading}
              onCustomTextChange={handleCustomTextChange}
              onSizeChange={handleSizeChange}
              onDownload={handleDownload}
              onPrint={handlePrint}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};
